<template>
  <div class="grafico-line-faturamento">    
      <div class="row" >
        <div class="col-sm-12 col-md-2 col-lg-2">
            <label for="cbagrupamento">Agrupar por:</label>
            <!-- a position tem que ser relative para que funcione -->
            <select style="position: relative; z-index: 10;" class="form-control form-control-sm" id="cbagrupamento" @change="mtdrelatoriomapavendas()" v-model="agrupamento">
                <option value="0">Dia</option>
                <option value="1">Mês</option>
                <option value="2">Ano</option>
            </select>
        </div> 
      </div>
      <div class="row">
        <div class="col-md-12" style="margin-top: -40px;">
            <graficoline :titulo="''"
                    :agrupamento="agrupamentograficoline"
                    :series="seriesgraficoline"
            ></graficoline>
        </div>
      </div>


      <div class="row">
        <div class="col-md-12 mb-2">
            <h6>
            Total custo no período:
            <span class="badge bg-danger text-dark"> {{ mtdformatavalordecimal(parseFloat(vtotcusto), 2) }}</span>
            </h6>
        </div>
        <div class="col-md-12">
            <h6>
            Total venda no período:
            <span class="badge bg-info text-dark"> {{ mtdformatavalordecimal(parseFloat(vtotvenda), 2) }}</span>
            </h6>
        </div>
     </div>

  </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
import GraficoLine from '../../components/cmpgraficoline.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
import { watch } from 'vue';
export default {
  name: "variacaofaturamento",

  components:{
    'graficoline'		: GraficoLine,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        seriesgraficoline : [],

        agrupamentogrupo        : 0,
        agrupamento             : 0,
        margemlucrogeral        : 0,
        showpopover             : false,
        isloading               : false, 
        vtotvenda               : 0,
        vtotcusto               : 0,

        usuariologado           : this.$store.state.usuario,

        agrupamentograficoline  : []
        

    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
  ],
  methods:{
        mtdformatavalordecimal(valor, digitos){
			return util.formatavalordecimais(valor, digitos);
		},  
        mtdrelatoriomapavendas(){
            let vself   = this;
            vself.$emit('handlerLoader', true);
            let filtro  = ' and p.dtfatura between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
            if (vself.lstfiliais.length > 0) {
                let stringfilial = vself.lstfiliais.join(',');
                filtro  = filtro  + ' and p.idfilial in (' + stringfilial + ')';
            }
            let filtrorecebimento       = ' and t.dthrlancamento between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
            if (vself.lstfiliais.length > 0) {
                let stringfilial = vself.lstfiliais.join(',');
                filtrorecebimento  = filtrorecebimento  + ' and p.idfilial in (' + stringfilial + ')';
            }
            let vizualiza = [0,1];
            
            // let loader      			= vself.$loading.show();
            vself.isloading = true;
            let parametros  			= [
                {parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           	    valor : 'mapavendas'},
                {parametro: 'agrupamento',          valor : vself.agrupamento},
                {parametro: 'agrupgrupo',           valor : vself.agrupamentogrupo},
                {parametro: 'vizualiza',            valor : vizualiza},
                {parametro: 'filtro', 	            valor : filtro},
                {parametro: 'filiais',              valor : JSON.stringify(vself.lstfiliais)},
                {parametro: 'filtrorecebimentos', 	valor : filtrorecebimento},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
            retorno.then(function (response) {
                vself.lstmapavendas       = response.data.agrupamento;
             

                vself.totalqtdvenda    = 0;//reseta as variaveis
                vself.totalticketmedio = 0;
                for (let index = 0; index < vself.lstmapavendas.length; index++) {
                    vself.totalqtdvenda    = vself.totalqtdvenda    + parseInt(vself.lstmapavendas[index].qtdpedidos)
                    vself.totalticketmedio = vself.totalticketmedio + vself.lstmapavendas[index].tiketmedio
                }
                
                // gera os dados para o gráfico de linha custo/venda
                vself.agrupamentograficoline = util.gerarseriegrafico(vself.lstmapavendas, 'agrupamento');
                let seriecusto = {
                    name: 'Custo',
                    type: 'line',
                    data: util.gerarseriegrafico(vself.lstmapavendas, 'totalcusto')
                };
                let serievenda = {
                    name: 'Venda',
                    type: 'line',
                    data: util.gerarseriegrafico(vself.lstmapavendas, 'totalvenda')
                };                    
                vself.seriesgraficoline = [];
                vself.seriesgraficoline.push(seriecusto);
                vself.seriesgraficoline.push(serievenda);

                vself.vtotvenda = response.data.totalgeralvenda;
                vself.vtotcusto = response.data.totalgeralcusto;

 	
                vself.$emit('handlerLoader', false);
            }).catch(function (response) {
                vself.lstmapavendas       = [];
            
                vself.$emit('handlerLoader', false);
            });    
        },
  },
  mounted(){
    //Recupera estado do 'agrupar por'
    let agrupamentoStore = localStorage.getItem('agrupamento');

    if(agrupamentoStore){
        this.agrupamento =  parseInt(agrupamentoStore);
    }
    setTimeout(() => {
        this.mtdrelatoriomapavendas();
    }, 3000);
  },
  computed:{
            
  },
  watch:{
    agrupamento(val){
        window.localStorage.setItem('agrupamento', val);
    }
  }
}
</script>
<style>
    @media (max-width: 576px) {
        .grafico-individual .echarts {
            width: 300px;
            height: 400px;
        }        
        .grafico-line-faturamento .echarts{
            width: 300px;
            height: 250px;        
        }        
    }  
    @media (min-width: 577px) {
        .grafico-individual .echarts {
            width: 500px;
            height: 600px;
        }        
        .grafico-line-faturamento .echarts{
            width: 550px;
            height: 220px;        
        }        
    }  
    @media (min-width: 1024px) {
        .grafico-individual .echarts {
            width: 1024px;
            height: 828px;
        }       
        .grafico-line-faturamento .echarts{
            width: 1024px;
            height: 400px;        
        }        
    }     
</style>
